import constants from "./constants";
import _ from "lodash";

export const isModuleFinished = (finishedTopicsIds, moduleId, topics) => {
  const moduleTopics = topics.filter((t) => t.parentContentId === moduleId);
  const moduleTopicsIds = moduleTopics.map((i) => i.contentKey);
  return (
    _.intersection(moduleTopicsIds, finishedTopicsIds).length ===
    moduleTopicsIds.length
  );
};

export const isAllSubTopicsCompleted = (finishedSubTopicsIds, parts, topic) => {
  const listOfSubKeys = parts.filter(item => item.contentKey !== `${topic.contentKey}-0`).map( item => item.contentKey);
  return _.intersection(finishedSubTopicsIds,listOfSubKeys).length === listOfSubKeys.length;
};

export const isAllSubTopicsCompletedExceptThirdOne = (finishedSubTopicsIds, parts, topic) => {
  const listOfSubKeys = parts.filter(item => item.contentKey !== `${topic.contentKey}-0` && item.contentKey !== `${topic.contentKey}-3`).map( item => item.contentKey);
  return _.intersection(finishedSubTopicsIds,listOfSubKeys).length === listOfSubKeys.length;
};

export const isSectionFinished = (finishedTopicsIds, allTopics, section) => {
  const topicIds = allTopics
    .filter((i) => i.pmApproach.includes(section))
    .filter((i) => !i.contentKey.includes("introduction"))
    .map((i) => i.contentKey);

  return _.intersection(topicIds, finishedTopicsIds).length === topicIds.length;
};

export const generateReactHelmetScripts = (adobeSettings) => {
  const isProd = window.location.hostname.includes(constants.prodHostName);

  const adobeRefreshScripts = [
    {
      src: adobeSettings.adobeSrcUrl,
      type: "text/javascript",
    },
    {
      src: adobeSettings.adobeDataLayerUrl,
      type: "text/javascript",
    },
    {
      src: adobeSettings.adobeEventListenerUrl,
      type: "text/javascript",
    },
  ];

  const adobeOldScripts = [
    {
      type: "text/javascript",
      innerHTML: `     
        vAdobeAnalyticsEnabled = "True";
        PmiTag = {};
        PmiTag.Channel = "PMIperfectkickoff";
        PmiTag.pageName = "PMIperfectkickoff|${isProd ? "Home" : "Lowers"}";
      `,
    },
    {
      src: "vendor/adobeScripts.js",
      type: "text/javascript",
    },
  ];

  let scriptsArray = [
    // TODO hidden until sweepstakes ready to deploy
    // {
    //   src: "vendor/gleam.js",
    //   type: "text/javascript"
    // }
  ];

  if (isProd) {
    scriptsArray = [
      ...scriptsArray,
      {
        src: "vendor/growsumo.js",
        type: "text/javascript",
      },
    ];
  }

  if (adobeSettings && adobeSettings.isAdobeRefreshEnabled) {
    scriptsArray = [...scriptsArray, ...adobeRefreshScripts];
  } else {
    scriptsArray = [...scriptsArray, ...adobeOldScripts];
  }

  return scriptsArray;
};

export const decodedToken = () => {
  return JSON.parse(atob(localStorage.token.split('.')[1]))
}

export const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.exp * 1000 < Date.now() + 10 * 1000 //10sec before expiration
  } catch {
    return true
  }
}